import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";

export default function ScrollBarDynamic({
  id,
  children,
  ornt = "vertical",
  style,
  fullWidth,
  handleTabChange,
  auto,
  height,
  indicatorWidth,
  valueExt,
}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (handleTabChange) handleTabChange(event, newValue);
  };

  return fullWidth === undefined ? (
    <Box
      id={id !== undefined ? id : "scrollBarDynamic"}
      style={{
        maxWidth: "480px",
        display: "flex",
        height: height ? height : "100%",
        ...style,
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        orientation={ornt}
        variant="scrollable"
        scrollButtons="on"
        TabIndicatorProps={{
          style: {
            backgroundColor: indicatorWidth ? "" : "transparent",
            width: indicatorWidth ? indicatorWidth : "0px",
          },
        }}
        style={{ width: "100%", minHeight: "30px" }}
      >
        {children}
      </Tabs>
    </Box>
  ) : (
    <Tabs
      value={valueExt ? valueExt : value}
      onChange={handleChange}
      orientation={ornt}
      variant="scrollable"
      scrollButtons={auto ?? "on"}
      style={{
        width: "100%",
        ...style,
      }}
    >
      {children}
    </Tabs>
  );
}
